import React from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import '../assets/css/q2cui_oss.css';
import '../assets/css/oswidget.css';
import '../assets/css/oswidgetexpert.css';
import 'react-toastify/dist/ReactToastify.css';
import './order-notification.css';

import {BasicAlert} from '../common/components.jsx';
import * as _ from "lodash";

export class NotificationModal extends React.PureComponent {

  constructor(props) {
    super(props);   
    this.state = {
      notification: {},
      loading : true
    }
    this.handleSave      = this.handleSave.bind(this);
    this.handleChange    = this.handleChange.bind(this);
    this.handleCancel    = this.handleCancel.bind(this);
    this.handleAddEmail  = this.handleAddEmail.bind(this);
    this.handleDeleteEmail = this.handleDeleteEmail.bind(this);
    this.handleEmailSendTypeChange = this.handleEmailSendTypeChange.bind(this);
    this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
    this.initNotificationState = this.initNotificationState.bind(this);
  }

  componentDidMount() {

    if (this.props.order) {
      this.initNotificationState(this.props.order);
    } else {
      var legacy_order_no = this.props.legacy_order_no;
      var notificationSetup = [];
      var self = this;
      GET('/os/ossui/v1/in/widgetExpert/getSingleSubscription', {legacy_order_no}, function( notificationObj ) {
  
        if (notificationObj.length > 0) {
          for (var i = 0; i < notificationObj.length; i++) {
            notificationSetup.push(notificationObj[i]);
          }
        }
  
        if (notificationSetup.length > 0 ) {
          self.initNotificationState(notificationSetup[0]);
        }

      }); 
    }

  }

  initNotificationState(notificationFromDB){
    var notification = {
      legacy_order_no  : notificationFromDB.legacy_order_no,
      timing           : notificationFromDB.timing,
      user_id          : notificationFromDB.user_id,
      emailToUsers     : notificationFromDB.users,
      chkOptions :  {
                      Ack         : notificationFromDB.options.find(element => element == "Ack")         ? true : false,
                      orderChn    : notificationFromDB.options.find(element => element == "orderChn")    ? true : false,
                      sddChn      : notificationFromDB.options.find(element => element == "sddChn")      ? true : false,
                      statSubmit  : notificationFromDB.options.find(element => element == "statSubmit")  ? true : false,
                      statAdmin   : notificationFromDB.options.find(element => element == "statAdmin")   ? true : false,
                      statAcked   : notificationFromDB.options.find(element => element == "statAcked")   ? true : false,
                      statProd    : notificationFromDB.options.find(element => element == "statProd")    ? true : false,
                      statPDone   : notificationFromDB.options.find(element => element == "statPDone")   ? true : false,
                      statShipF   : notificationFromDB.options.find(element => element == "statShipF")   ? true : false,
                      statRegis   : notificationFromDB.options.find(element => element == "statRegis")   ? true : false,
                      statShip    : notificationFromDB.options.find(element => element == "statShip")    ? true : false,
                      statDelv    : notificationFromDB.options.find(element => element == "statDelv")    ? true : false,
                      statCanc    : notificationFromDB.options.find(element => element == "statCanc")    ? true : false,
                      statInv     : notificationFromDB.options.find(element => element == "statInv")     ? true : false,
                      holdEntry   : notificationFromDB.options.find(element => element == "holdEntry")   ? true : false,
                      holdFulfill : notificationFromDB.options.find(element => element == "holdFulfill") ? true : false,
                      holdShip    : notificationFromDB.options.find(element => element == "holdShip")    ? true : false,
                      holdBill    : notificationFromDB.options.find(element => element == "holdBill")    ? true : false,
                      holdFallout : notificationFromDB.options.find(element => element == "holdFallout") ? true : false,
                    },
      chkFormat :  {
                      formatHead  : notificationFromDB.format.find(element => element == "formatHead")   ? true : false,
                      formatItem  : notificationFromDB.format.find(element => element == "formatItem")   ? true : false,
                      formatPrice : notificationFromDB.format.find(element => element == "formatPrice")  ? true : false,
                      formatShip  : notificationFromDB.format.find(element => element == "formatShip")   ? true : false,
                      formatSplit : notificationFromDB.format.find(element => element == "formatSplit")  ? true : false,
                    },
    }

    this.setState({
      loading : false,
      notification: notification
    });
  }

  handleSave() {
    
    var notification = this.state.notification;

    var options = Object.keys(notification.chkOptions);
    var newOptions = [];

    for (var x in options){
      if (notification.chkOptions[options[x]] == true) {
        newOptions.push(options[x]);
      }
    }

    var format = Object.keys(notification.chkFormat);
    var newFormat = [];

    for (var x in format){
      if (notification.chkFormat[format[x]] == true) {
        newFormat.push(format[x]);
      }
    }

    var notificationNew = {
      legacy_order_no : notification.legacy_order_no,
      options         : newOptions,
      format          : newFormat,
      users           : notification.emailToUsers,
      timing          : notification.timing
    }

    axios.post('/os/ossui/v1/in/widgetExpert/saveSubscription', {
      customizedNotification: notificationNew
    })
    .then(response => {
      var message = "notification sucessfully edited";
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
      if (this.props.onChange) {
        this.props.onChange(notificationNew);
      }
    })
    .catch(error => {
      toast.error(error.response.statusText, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });  
    });


  }

  handleChange(e) {

    var notificationNew = _.cloneDeep(this.state.notification);

    if (e.target.type == "checkbox") {

      if (e.target.value.match("format")) {
        notificationNew.chkFormat[e.target.value] = e.target.checked;
      } else {
        notificationNew.chkOptions[e.target.value] = e.target.checked;
      }

      this.setState({
        notification: notificationNew
      });

    } else if (e.target.type == "radio") {

      notificationNew.timing = e.target.name

      this.setState({
        notification: notificationNew
      });

    }

  }

  handleCancel() {
    if (this.props.onCancel) {
        this.props.onCancel();
    }
  }

  handleAddEmail(e){

    var notificationNew = _.cloneDeep(this.state.notification);
    notificationNew.emailToUsers.push({type: "T", email: ""})

    this.setState({
      notification: notificationNew
    });

  }

  handleDeleteEmail(e, send, email){

    var notificationNew = _.cloneDeep(this.state.notification);
    const index      = notificationNew.emailToUsers.findIndex(x => x.email === 'email');
    notificationNew.emailToUsers.splice(index, 1);

    this.setState({
      notification: notificationNew
    });

  }

  handleEmailSendTypeChange(e, email){

    var notificationNew = _.cloneDeep(this.state.notification);
    var newMode = e.target.value;
    var previousMode;

    if (newMode == "T") {
      previousMode = "C";
    } else {
      previousMode = "T";
    }

    const index      = notificationNew.emailToUsers.findIndex(x => x.email === email && x.type === previousMode);
    notificationNew.emailToUsers[index].type = newMode;

    this.setState({
      notification: notificationNew
    });

  }

  handleEmailInputChange(e){
    let notificationNew = _.cloneDeep(this.state.notification);
    let index = e.target.id.split("_")[3];

    notificationNew.emailToUsers[index].email = e.target.value;

    this.setState({
      notification: notificationNew
    });    

  }

  createEmailToFields() {

    let allEmailAddresses = [];
    return allEmailAddresses;

    // Disabled for now. If needed in future, also SendNotification.tcl and sendEmailTemplate route needs work
    var emails = this.state.notification.emailToUsers;
    let emailCount = emails.length;
    let addEmail = null;
    if (emailCount == 0) {
      allEmailAddresses.push (
        <div>
          <input type="button" className="btn btn-primary btn-sm" name="addmore" value="add email reciepient ..." onClick={(e) => this.handleAddEmail(e)}/>
        </div>
      )
    }

    for (var x = 0; x < emailCount; x++) {

      let send  = emails[x].type;
      let email = emails[x].email;

      if (emailCount == x + 1) {
        addEmail = <i className="glyphicon glyphicon-plus" style={{ color: "#0096d6", cursor: "pointer", margin: "0 4px 0 15px" }} onClick={(e) => this.handleAddEmail(e)}></i>
      }

      allEmailAddresses.push(
              <div key={x}>
                <i className="glyphicon glyphicon-minus" style={{ color: "#0096d6", cursor: "pointer",  margin: "0 4px 0 15px" }} onClick={(e) => this.handleDeleteEmail(e, send, email)}></i>
                <select value={send} style={{ height: "30px" }} name={'ot_' + send + '_' + x} onChange={(e) => this.handleEmailSendTypeChange(e, email)}>
                  <option value="C" >CC</option>
                  <option value="T" >To</option>
                </select>
                <input type="text" size="50" style={{ height: "30px" }} id={'on_to_' + send + '_' + x} name={'on_to_' + send + '_' + x} value={email} onChange={(e) => this.handleEmailInputChange(e)}/>
                {addEmail}
              </div>)
    }
    return allEmailAddresses
  }

  render() {

    var modalBody;
    if (this.state.loading === true) {
      modalBody = <div className="modal-body">
                      <BasicAlert type="L" /> 
                    </div>
    } else {
      var notification = this.state.notification;
      var emailReciepientsFields = this.createEmailToFields();
      modalBody =  <div className="modal-body">
        <h4>Select the events you want to be notified about:</h4>  
                    <div id="checkboxes" className="flex-row">
                      <section className="sel-group">
                        <ul>
                          <li><input type="checkbox" value="Ack"      onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.Ack}      /> Acknowledgement </li>
                          <li><input type="checkbox" value="sddChn"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.sddChn}   /> Delivery Date Change </li>
                          <li><input type="checkbox" value="orderChn" onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.orderChn} /> Order Change </li>
                        </ul>
                        <section className="sel-group spaced-top">
                          <label>Hold Categories</label>
                          <ul>
                            <li><input type="checkbox" value="holdEntry"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.holdEntry}   /> Order Entry </li>
                            <li><input type="checkbox" value="holdFulfill" onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.holdFulfill} /> Factory Fulfillment </li>
                            <li><input type="checkbox" value="holdShip"    onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.holdShip}    /> Shipping </li>
                            <li><input type="checkbox" value="holdBill"    onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.holdBill}    /> Billing </li>
                            <li><input type="checkbox" value="holdFallout" onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.holdFallout} /> Fallout </li>
                          </ul>
                        </section>
                      </section>
                      <section className="sel-group">
                        <label>Status Change</label>
                        <ul>
                          <li><input type="checkbox" value="statSubmit" onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statSubmit} /> Submitted </li>
                          <li><input type="checkbox" value="statAdmin"  onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statAdmin}  /> Admin/Processing </li>
                          <li><input type="checkbox" value="statAcked"  onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statAcked}  /> Admin/Acked </li>
                          <li><input type="checkbox" value="statProd"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statProd}   /> Production / Shipment Scheduled </li>
                          <li><input type="checkbox" value="statPDone"  onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statPDone}  /> ProductionDone </li>
                          <li><input type="checkbox" value="statShipF"  onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statShipF}  /> Shipped from Factory </li>
                          <li><input type="checkbox" value="statRegis"  onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statRegis}  /> Registered </li>
                          <li><input type="checkbox" value="statShip"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statShip}   /> Shipped to Customer </li>
                          <li><input type="checkbox" value="statDelv"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statDelv}   /> Delivered </li>
                          <li><input type="checkbox" value="statCanc"   onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statCanc}   /> Canceled </li>
                          <li><input type="checkbox" value="statInv"    onChange={(e) => this.handleChange(e)} checked={notification.chkOptions.statInv}    /> Invoiced </li>
                        </ul>
                      </section>
                      <section className="sel-group">
                        <h4>Send notification</h4>
                        <div className="radio-group">
                        <input type="radio" ref="immediate" name="immediate" id="immediate"  onChange={(e) => this.handleChange(e)} checked={notification.timing == "immediate" ? 'checked' : ''}/>
                          <label htmlFor="immediate"> For individual events immediately</label>
                          </div>
                          <ul>
                            <li><input type="checkbox" value="formatHead"   onChange={(e) => this.handleChange(e)} checked={notification.chkFormat.formatHead}  /> Header Information </li>
                            <li><input type="checkbox" value="formatItem"   onChange={(e) => this.handleChange(e)} checked={notification.chkFormat.formatItem}  /> Item Information </li>
                            <li><input type="checkbox" value="formatPrice"  onChange={(e) => this.handleChange(e)} checked={notification.chkFormat.formatPrice} /> Pricing Information </li>
                            <li><input type="checkbox" value="formatShip"   onChange={(e) => this.handleChange(e)} checked={notification.chkFormat.formatShip}  /> Shipment Information </li>
                            <li><input type="checkbox" value="formatSplit"  onChange={(e) => this.handleChange(e)} checked={notification.chkFormat.formatSplit} /> Include Split Information </li>
                          </ul>
                          <section className="sel-group spaced-top">
                            <div className="radio-group">
                              <input type="radio" ref="combine" name="combine" id="combine" onChange={(e) => this.handleChange(e)} checked={notification.timing == "combine" ? 'checked' : ''}/>
                              <label htmlFor="combine"> Combined once a day</label>     
                            </div>    
                          </section>  
                        </section>
                    </div>
                    <div className="form-row">
                      <section className="sel-group">
                        {emailReciepientsFields}
                      </section>
                    </div>
                  </div>
    }

    return (
    <div className="modal order-notification" style={{ "display": "block"}}>
      <ToastContainer position='bottom-right' />
      <div className="modal-dialog modal-lg" style={{ "width": "900px" }} >
          <div className="modal-content">
              <div className="modal-header">
                  <h3 className="modal-title">Notification Setup for OrderNo: {this.props.hp_order_no} (PO No: {this.props.hp_order_no})</h3>
              </div>    
              {modalBody}                                                                                              
              <div className="modal-footer">
                <button type="button" onClick={this.handleSave}   className="btn btn-primary">Save</button>
                <button type="button" onClick={this.handleCancel} className="btn btn-info">Cancel</button>
              </div>
          </div>
      </div>
    </div>
    )
  }
}
